(() => {
  const form = document.getElementById('ContactForm');
  if (!form || window.Shopify?.designMode || form.dataset.drLeadTracking) return;
  form.dataset.drLeadTracking = 'true';
  form.dataset.drLeadStatus = 'form_ready';
  const key = 'dr_contact_pending_v1';
  const maxAge = 2 * 60 * 60 * 1000;
  const readPending = () => {
    try {
      const item = JSON.parse(sessionStorage.getItem(key));
      return item && typeof item.id === 'string' &&
        Number.isFinite(item.at) && Date.now() >= item.at &&
        Date.now() - item.at < maxAge ? item : null;
    } catch { return null; }
  };
  if (!form.querySelector('.kf-ok')) {
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      try {
        const id = window.crypto?.randomUUID?.();
        if (id) sessionStorage.setItem(key, JSON.stringify({ id, at: Date.now() }));
      } catch {}
    }, true);
    return;
  }
  const pending = readPending();
  if (!pending) { form.dataset.drLeadStatus = 'no_submission_marker'; return; }
  form.dataset.drLeadStatus = 'waiting_for_consent';
  const measurementId = 'G-PFR2P29X5Y';
  let loading = false;
  let sent = false;
  let configured = false;
  const tag = function () { window.drLeadDataLayer.push(arguments); };
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return !!privacy && privacy.analyticsProcessingAllowed() === true &&
      privacy.marketingAllowed() === true;
  };
  const send = () => {
    if (sent || loading || !allowed() || readPending()?.id !== pending.id) return;
    loading = true;
    form.dataset.drLeadStatus = 'loading_tag';
    window.drLeadDataLayer = window.drLeadDataLayer || [];
    if (!configured) {
      tag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    tag('js', new Date());
    tag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      page_location: location.origin + location.pathname
    });
      configured = true;
    }
    tag('consent', 'update', {
      analytics_storage: 'granted', ad_storage: 'granted',
      ad_user_data: 'denied', ad_personalization: 'denied'
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' +
      measurementId + '&l=drLeadDataLayer';
    script.onerror = () => { loading = false; form.dataset.drLeadStatus = 'tag_load_failed'; script.remove(); };
    script.onload = () => {
      loading = false;
      if (sent || !allowed() || readPending()?.id !== pending.id) return;
      try { sessionStorage.removeItem(key); } catch { return; }
      sent = true;
      form.dataset.drLeadStatus = 'event_queued';
      tag('event', 'generate_lead', {
        send_to: measurementId,
        form_id: 'ContactForm',
        lead_source: 'digital_rollup_contact',
        event_id: pending.id,
        page_location: location.origin + location.pathname
      });
    };
    document.head.appendChild(script);
  };
  document.addEventListener('visitorConsentCollected', () => {
    if (allowed()) send();
    else if (window.drLeadDataLayer) tag(
      'consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
      }
    );
  });
  if (window.Shopify?.customerPrivacy) send();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }],
      error => { if (!error) send(); });
  }
})();
